import { useQuery as e } from "@maat/store-hooks";
import { aiApi as t } from "@maat/api-ai";
//#region src/ai/useAiGenerateQuery.ts
var n = (n, r, i) => e({
	queryKey: [
		"ai",
		"generate",
		n,
		r
	],
	queryFn: () => t.generate(n, r),
	enabled: i?.enabled ?? !0,
	staleTime: Infinity,
	refetchOnWindowFocus: !1,
	retry: !1
});
//#endregion
export { n as useAiGenerateQuery };
